import { render } from "./ExpenseIcon.vue?vue&type=template&id=b8c1adda"
import script from "./ExpenseIcon.vue?vue&type=script&lang=js"
export * from "./ExpenseIcon.vue?vue&type=script&lang=js"
script.render = render

export default script